// extracted by mini-css-extract-plugin
export default {"main":"index_rem_main__bgu0g","info":"index_rem_info__4RmSc"};